module.exports = __webpack_public_path__ + "static/media/logoHostPms.05e83fa2.ico";